import styled from 'styled-components';
import {borderRadius, transition} from '../../settings/style-util';

const TopbarNotificationStyled = styled.div`
  position: relative;
  left: 0;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 420px;
  height: calc(100vh - 100px);
  overflow: auto;
  background-color: #fff;
  ${borderRadius('5px')};
  ${transition()};

  @media only screen and (width <= 767px) {
    width: calc(100vw - 8px);
    max-width: 420px;
  }

  @media only screen and (width <= 575px) {
    width: calc(100% - 8px);
  }
  
  .ant-modal-close {
    top: 3px;
  }

  .heading-row {
    height: 32px;
    min-height: 32px;
    padding: 0 16px;
    margin-bottom: 10px;
    overflow: hidden;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    color: rgba(0, 0, 0, 85%);
    text-overflow: ellipsis;
    white-space: nowrap;
    user-select: none;
  }

  .divider {
    margin: 0;
  }

  .content-container {
    display: flex;
    flex-flow: column nowrap;
    padding: 0 16px;
    margin-top: 16px;
  }

  .group-heading-row {
    display: flex;
    justify-content: space-between;
    margin: 8px 0 4px;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.45454545;
    color: #8993a4;
    text-transform: uppercase
  }

  .list-item-group {
    &:last-child {
      /* margin-bottom: 50vh; */
    }

    .list-item-container {
      display: flex;
      flex-flow: row nowrap;
      width: 100%;
      min-height: 70px;
      padding: 8px 4px;
      margin-bottom: 1px;
      border-radius: 3px;

      /* border-top: 1px solid rgba(170, 170, 170, 7%); */

      ${transition()}
      &:last-child {
        /* border-bottom: 1px solid rgba(170, 170, 170, 7%); */
        margin-bottom: 16px;
      }

      &:hover {
        background: #f8f8f8;

        .list-item-read-col .list-item-content-clear-button {
          opacity: 1;
        }

        .list-item-read-col .list-item-content-read-button.read {
          background: #c2c2c2;
        }
      }

      &.clickable {
        cursor: pointer;
      }

      &.unread {
        background: #e6f7ff;
        
        &:hover {
          background: #bae7ff70;
        }
      }

      .list-item-avatar {
        display: flex;
        justify-content: center;
        margin: 2px 12px 0 0;

        .icon {
          width: 8px;
          height: 8px;
          margin-top: 3px;
          margin-left: 8px;
          background: black;
          border-radius: 50%;
        }
        

        .ant-avatar.ant-avatar-circle.ant-avatar-icon {
          background: #172b4d;
        }
      }

      .list-item-content-container {
        position: relative;
        display: flex;
        flex: 1;
        flex-flow: column nowrap;
        min-width: 0;
        font-size: 14px;
        line-height: 18px;

        .list-item-content-title {
          overflow: hidden;
          font-weight: 600;
          color: #172b4d;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .list-item-content-subtitle {
          color: #172b4d;

          /* overflow: hidden; */
          /* text-overflow: ellipsis; */
          /* white-space: nowrap; */
        }

        .list-item-content-time-elapsed {
          font-size: 12px;
          color: #8993a4;
        }
      }

      .list-item-read-col {
        position: relative;
        width: 18px;
        margin-left: 8px;
      }
    }
  }
`;

export default TopbarNotificationStyled;
